// extracted by mini-css-extract-plugin
export default {"menu":"AdminView_menu__ZSC0e","content":"AdminView_content__8JcWS"};